import _ from 'underscore';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

const s$AdGroup = window.globalLegacySchema.get('AdGroup');

export default class ViewModel {
  constructor(AdRotation = 'OptimizeForClicks', disableRotationOptions) {
    koSchema.properties(this, s$AdGroup, ['AdRotation'], {
      AdRotation,
    });
    _.extend(this, { disableRotationOptions });
  }
}
